import { deleteCall, get, post } from '.';

export type DelegatedProposalToken = {
    id: number;
    sharedWith: string;
    expiredAt: string | null;
    createdAt: string | null;
    updatedAt: string | null;
};

export const getDelegatedProposalTokens = (proposalId: number | string) =>
    get(`proposals/${proposalId}/delegated-tokens`, { showErrorCode: true }) as Promise<{
        success: boolean;
        delegatedTokens: DelegatedProposalToken[];
    }>;

export const createDelegatedProposalToken = (proposalId: number | string, sharedWith: string) =>
    post(`proposals/${proposalId}/delegated-tokens`, { sharedWith }, { showErrorCode: true }) as Promise<{
        success: boolean;
        sharedWith: string;
        emailSent: boolean;
        resent: boolean;
    }>;

export const revokeDelegatedProposalToken = (proposalId: number | string, delegatedTokenId: number) =>
    deleteCall(`proposals/${proposalId}/delegated-tokens/${delegatedTokenId}`, {}, { showErrorCode: true }) as Promise<{
        success: boolean;
    }>;
